<template>
  <div class="bob-page-title">
    <div class="flex items-center">
      <slot name="icon">
        <div v-if="computedConfig.icon" class="cursor-pointer" @click="computedConfig.iconClick">
          <MaterialIcon class="select-none" style="margin-right: 9px;">
            {{ computedConfig.icon }}
          </MaterialIcon>
        </div>
      </slot>
      <span v-if="computedConfig.titleHint" class="title-hint" :style="`font-size: ${computedConfig.titleSize}px`">|</span>
      <span class="title-text" :style="`font-size: ${computedConfig.titleSize}px`">{{ computedConfig.title }}</span>
      <TipInfo v-if="computedConfig.titleTip" class="ml-[8px] text-gray-60" :size="16">{{ computedConfig.titleTip }}</TipInfo>
    </div>

    <div class="actions">
      <component
        :is="action.component"
        v-for="action in computedConfig.actions"
        :key="action.key"
        v-featureKey="action.featureKey"
        class="actions-item"
        v-bind="action.props"
        v-on="action.on"
      >
        <FlexLayout
          class="w-full"
          :justify="action.layout?.justify || 'center'"
          :align="action.layout?.align || 'center'"
          :gap="action.layout?.gap || 0"
          :col="action.layout?.col || false"
        >
          <div v-if="action.render">{{ action.render() }}</div>
          <template v-for="(child, childIndex) in action.childs || []">
            <component
              :is="child.component"
              :key="childIndex"
              v-bind="child.props"
              v-on="child.on"
            >
              <div v-if="child.render">{{ child.render() }}</div>
              <template v-for="(slot, slotName) in child.slots || {}">
                <component
                  :is="slot.component"
                  v-if="typeof slot === 'object'"
                  :key="slotName"
                  :slot="slotName"
                  v-bind="slot.props"
                >
                  <div v-if="slot.render">{{ slot.render() }}</div>
                </component>
              </template>
            </component>
          </template>
        </FlexLayout>
      </component>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import TipInfo from '@/components/TipInfo.vue'

export default defineComponent({
  name: 'BobPageTitle',
  components: { TipInfo },
  props: {
    config: {
      type: Object,
      default: () => ({
        title: '',
        titleSize: 20,
        actions: [],
      }),
    },
  },
  setup (props, { emit }) {
    const defaultConfig = {
      title: '',
      titleSize: 20,
      actions: [],
      icon: null,
      iconClick: () => {},
      titleHint: false,
      titleTip: null,
    }

    const computedConfig = computed(() => {
      return { ...defaultConfig, ...props.config }
    })

    return { computedConfig }
  },
})
</script>

<style lang="postcss" scoped>
.bob-page-title {
  @apply flex justify-between mb-[24px];

  .title-hint {
    @apply mr-[5px] text-primary-100 font-medium;
  }
}

.title-text {
  @apply text-gray-100 font-medium;
}

.actions {
  @apply flex items-center gap-[8px];
}

.actions-item {
  @apply min-w-[100px];
}
</style>
